import { render } from "./NewValidationRule.vue?vue&type=template&id=b9cd4afc"
import script from "./NewValidationRule.vue?vue&type=script&lang=js"
export * from "./NewValidationRule.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__